import "./src/styles/global.css"
import 'prismjs/themes/prism-tomorrow.css';